module.exports = __webpack_public_path__ + "img/logo_horizontal_old.7a86464b.png";